module.exports = __webpack_public_path__ + "img/logosis.14b5a1b6.png";